import { useTranslation } from 'react-i18next';
import { DoughnutChart } from 'src/common/components/Graphs/common/Graphs/DoughnutChart';
import { useRSimStatus } from './hooks/useRSimStatus';

type RSimStatusChartProps = {
  accountRef: string;
};

export const RSimStatusChart = (props: RSimStatusChartProps) => {
  const { t } = useTranslation();

  const { total, chartData } = useRSimStatus(props);

  return (
    <DoughnutChart
      data={chartData}
      total={total}
      aria-label={t('dashboard.rSimStatusChart.title')}
    />
  );
};
